export default __webpack_public_path__ + "static/media/icn_close.ded40374.svg";